import { useAuth } from 'providers/Auth';

import { LoggedUser } from 'entities';

export function useUser(): LoggedUser {
  const {
    user: { data },
  } = useAuth();

  return data;
}
